import React, { useEffect, useState } from "react";
import Chat from "./components/chat/Chat";
import Dashboard from "./components/dashboard/Dashboard";
import { AssistantProvider } from "./context/AssistantContext";
import { UserProvider } from "./context/UserContext";
import { ConversationsProvider } from "./context/ConversationsContext";
import { NotificationProvider } from "./context/NotificationContext";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { parseAuthFromUrl, isAuthenticated, redirectToLogin } from "./utils/auth";
import "./App.css";

// Custom component to handle login redirect without cookies
const LoginRedirect = () => {
  useEffect(() => {
    redirectToLogin();
  }, []);
  
  return <div>Login...</div>;
};

function App() {
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    // Check URL for auth tokens on initial load
    const authResult = parseAuthFromUrl();
    
    // Set auth as checked whether we found tokens or not
    setAuthChecked(true);
    
    // If not authenticated after parsing URL, redirect to login
    if (!isAuthenticated() && !window.location.pathname.includes("/api/")) {
      redirectToLogin();
    }
  }, []);

  // Show nothing while checking auth to prevent flashes of content
  if (!authChecked) {
    return <div className="loading-auth">Loading...</div>;
  }

  return (
    <div className='App'>
      <AssistantProvider>
        <UserProvider>
          <NotificationProvider>
            <ConversationsProvider>
              <Router>
                <Routes>
                  <Route 
                    path='/c/:conversationId' 
                    element={
                      isAuthenticated() ? (
                        <Chat />
                      ) : (
                        <LoginRedirect />
                      )
                    } 
                  />
                  <Route 
                    path='/dashboard' 
                    element={
                      isAuthenticated() ? (
                        <Dashboard />
                      ) : (
                        <LoginRedirect />
                      )
                    } 
                  />
                  <Route 
                    path='/' 
                    element={
                      isAuthenticated() ? (
                        <Chat />
                      ) : (
                        <LoginRedirect />
                      )
                    } 
                  />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Router>
            </ConversationsProvider>
          </NotificationProvider>
        </UserProvider>
      </AssistantProvider>
    </div>
  );
}

export default App;
